import API from './apiConfig';


export const fetchProductCategories = async () => {
     const response = await API.get('api/category');
    return response.data; 
};
  